import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '../../common';

import { connectTo } from '../../../utils';
import { DOMAIN_LANGUAGE, NL } from '../../../constants/browser';

const Footer = ({
  styles,
  columns,
  isAuthenticated,
  LogoComponent: Logo,
  translations,
  logout,
}) => (
  <div className={styles['footer__wrapper']}>
    <div className={styles['footer__content']}>
      {Logo && (
        <div className={styles['footer__logo']}>
          <Logo />
        </div>
      )}
      {columns[DOMAIN_LANGUAGE] && columns[DOMAIN_LANGUAGE].length > 0 && (
        <div className={styles['footer__info-wrapper']}>
          <Grid
            container
            spacing={2}
            justify="space-between"
            className={styles['footer__info']}
          >
            {columns[DOMAIN_LANGUAGE].map((Component, index) => (
              <Grid
                item
                key={index}
                className={
                  styles[
                    `footer__info-item${DOMAIN_LANGUAGE === NL ? '_nl' : ''}`
                  ]
                }
              >
                <Component
                  {...{ styles, isAuthenticated, translations, logout }}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      )}
    </div>
  </div>
);

Footer.propTypes = {
  styles: PropTypes.object,
  columns: PropTypes.array,
  LogoComponent: PropTypes.any,
};

export default connectTo(
  ({ translations: { translations } }) => ({
    translations,
  }),
  {},
  Footer
);
